import React, {useEffect, useState} from 'react';
import ProcessFormField from './ProcessFormField';
import ProcessFieldSets from './ProcessFieldSets'
import { Submit } from './FormControls';
import tw from 'twin.macro';

const SinglePageForm = ({ 
    formFields, 
    formSubmit, 
    formState, 
    dispatch, 
    submitButton 
}) => {

    const [messageState, setMessage] = useState({});

    useEffect(()=>{
        if (formState.message?.type === "error"){
            const message = {};

            const messageText = JSON.parse(formState.message.text);
            console.log(messageText);
            setMessage(messageText)
        }
    }, [formState])

    const [fieldSets, setFieldSets] = useState([]);

    useEffect(()=>{
        const sectionFieldSets = []
        const sectionIndices = formFields
            .map((field, index)=> (field.type === 'section' && index) )
            .filter(index => index !== false);


        for (var i = 0; i < sectionIndices.length; i++){
            sectionFieldSets.push(formFields.slice(sectionIndices[i], sectionIndices[i + 1]))
        }
        setFieldSets(sectionFieldSets)
        
    },[])
    return(
    <div>
        {/* <pre>
            {JSON.stringify({ fieldSets }, null, 2)}
        </pre> */}

        <form onSubmit={formSubmit} id="quoteForm">
            <ProcessFieldSets formFields={formFields} dispatch={dispatch} formState={formState} />

            {/* {formState.message ? 
                <>
                    <div css={[
                        tw`p-4 border rounded mb-8 bg-green-100 border-green-300 text-green-600 text-sm`,
                        formState.message && tw`block`,
                        formState.message.type === 'error' && tw`bg-red-100 border-red-300 text-red-600`
                    ]}
                        dangerouslySetInnerHTML={{ __html: formState.message.text }}
                    />
                </>
            : null} */}

            <Submit label={submitButton?.text || "Submit"} loading={formState.submitting} />
            {(formState?.message?.text) && (
                <div 
                    tw="max-w-md px-5 py-3 bg-red-200 border-red-600 border my-5 rounded text-red-800" 
                    aria-live="polite"
                    role="alert"
                >
                    <p>It looks like there is some information missing. Please double check and try again.</p>
                </div>
            )}
        </form>
    </div>
)};

export default SinglePageForm;